import React from "react";
import { SearchOutlined } from "@ant-design/icons";

type SearchSectionProps = {
  placeholder: string;
  searchTerm: string;
  handleSearch: (value: string) => void;
};

export const SearchSection = ({
  placeholder,
  searchTerm,
  handleSearch,
}: SearchSectionProps) => {
  return (
    <div className="flex items-center justify-between p-[8px] border-b-[#E0E0E0] border-b">
      <div className="relative w-full">
        <SearchOutlined className="absolute left-[8px] top-1/2 -translate-y-1/2 text-[16px] text-gray-400" />
        <input
          type="text"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)}
          className="w-full border-[#E0E0E0] border rounded-[4px] px-[11px] pl-[32px] items-center bg-white overflow-hidden text-[14px] text-nowrap text-ellipsis h-[35px] focus:outline-[#64BDE1]"
        />
      </div>
    </div>
  );
};
